import type { Database } from '@shady-pines/db';
import type { SupabaseClient } from '@supabase/supabase-js';
import { create } from 'zustand';
import type { StateStorage } from 'zustand/middleware';

export type ApiState = {
  supabase: SupabaseClient<Database> | null;
  localStores: {
    track: StateStorage | null;
    user: StateStorage | null;
    show: StateStorage | null;
    event: StateStorage | null;
    popup: StateStorage | null;
    // globalContext: StateStorage | null;
  };
  localStoreRehydrationComplete: boolean;
};

type UtilityFunctions = {
  setInitialApiState: (state: Omit<ApiState, 'localStoreRehydrationComplete'>) => void;
  setRehydrationComplete: () => void;
};

const initialState = {
  supabase: null,
  localStores: {
    track: null,
    user: null,
    show: null,
    event: null,
    popup: null,
    // globalContext: null,
  },
  localStoreRehydrationComplete: false,
} as const satisfies ApiState;

export const useApiStore = create<ApiState & UtilityFunctions>((set) => ({
  ...initialState,
  setInitialApiState: (s) => set(s),
  setRehydrationComplete: () => set({ localStoreRehydrationComplete: true }),
}));

export const supabaseApi = () => useApiStore.getState().supabase!;
